const dateControl = () => {
 const DATA_CONTROL = `date-control`;

 const SELECTOR_WRAPPER = `.form-group`;

 const formatDate = (date, type = 'date') => {
 const year = date.getFullYear();
 const month = String(date.getMonth() + 1).padStart(2, `0`);
 const day = String(date.getDate()).padStart(2, `0`);

 if (type === 'month') return `${year}-${month}`;
 return `${year}-${month}-${day}`;
 };

 const applyDateControl = (wrapper, start, end) => {
 const startInput = wrapper.querySelector(`[data-${DATA_CONTROL}="start"]`);
 const endInput = wrapper.querySelector(`[data-${DATA_CONTROL}="end"]`);
 const inputEvent = new Event(`input`, { bubbles: true });

 if (!startInput || !endInput) return;

 const inputType = startInput.type || 'date';
 const formattedStart = start
 ? formatDate(new Date(start), inputType)
 : start;
 const formattedEnd = end ? formatDate(new Date(end), inputType) : end;

 startInput.value = formattedStart;
 endInput.value = formattedEnd;
 startInput.dispatchEvent(inputEvent);
 endInput.dispatchEvent(inputEvent);
 };

 const parseControlData = (data) => {
 const match = data?.match(/^([+-])(\d+)([dwmy])$/);

 if (!match) return null;

 return {
 sign: match[1],
 amount: parseInt(match[2]),
 unit: match[3],
 };
 };

 const calculateEndDate = (
 baseDate,
 { sign, amount, unit },
 inputType = 'date',
 ) => {
 const multiplier = sign === '+' ? 1 : -1;
 const date = new Date(baseDate);

 switch (unit) {
 case 'd':
 date.setDate(date.getDate() + amount * multiplier);
 break;
 case 'w':
 date.setDate(date.getDate() + amount * 7 * multiplier);
 break;
 case 'm':
 date.setMonth(date.getMonth() + amount * multiplier);
 break;
 case 'y':
 date.setFullYear(date.getFullYear() + amount * multiplier);
 break;
 }

 return formatDate(date, inputType);
 };

 const handleClick = ({ target }) => {
 const button = target?.closest(
 `[data-${DATA_CONTROL}]:not([data-${DATA_CONTROL}="start"], [data-${DATA_CONTROL}="end"])`,
 );

 if (!document.querySelector(`[data-${DATA_CONTROL}]`) || !button) return;

 const wrapper = button.closest(SELECTOR_WRAPPER);
 const controlData = button.getAttribute(`data-${DATA_CONTROL}`);
 const startInput = wrapper.querySelector(`[data-${DATA_CONTROL}="start"]`);
 const inputType = startInput?.type || 'date';

 if (controlData === `all`) {
 applyDateControl(wrapper, ``, ``);
 return;
 }

 const parsed = parseControlData(controlData);

 const today = new Date();
 const startDate = formatDate(today, inputType);

 if (!parsed) {
 applyDateControl(wrapper, startDate, startDate);
 return;
 }

 const endDate = calculateEndDate(today, parsed, inputType);

 parsed.sign === '+'
 ? applyDateControl(wrapper, startDate, endDate)
 : applyDateControl(wrapper, endDate, startDate);
 };

 const initialize = () => {
 document.body.addEventListener(`click`, handleClick);
 };

 initialize();

 dateControl.set = (wrapperEl, startDate, endDate) =>
 applyDateControl(wrapperEl, startDate, endDate);

 dateControl.cleanup = () => {
 document.body.removeEventListener(`click`, handleClick);
 };
};

export default dateControl;
